// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1AppObjectSchema = z.object({
  object_id: z.coerce.string().describe("Unique identifier for the app object"),
  etag: z.coerce.string().describe("ETag for versioning").nullish(),
  name: z.coerce.string().describe("Name of the app object"),
  auto_import: z.boolean().describe("Whether to automatically import this object"),
  project_id: z.number().int().describe("Associated Timely project ID").nullish(),
});
